import { usePwaInstall } from '@/hooks/usePwaInstall';
import { Button } from '@/components/ui/Button';
import { Download, X } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useState } from 'react';

export function PwaInstallButton({ className }: { className?: string }) {
  const { isInstallable, isInstalled, promptInstall } = usePwaInstall();
  const [dismissed, setDismissed] = useState(false);

  if (isInstalled || !isInstallable || dismissed) return null;

  return (
    <div className={cn('w-full', className)}>
      {/* Desktop: compact button inside sidebar */}
      <div className="hidden lg:block">
        <Button
          variant="outline"
          size="sm"
          className="w-full justify-start gap-2 border-[var(--color-primary)]/30 bg-[var(--color-primary)]/10 text-[var(--color-primary)] hover:bg-[var(--color-primary)]/20 hover:text-[var(--color-primary)]"
          onClick={promptInstall}
          data-testid="install-jani-button"
        >
          <Download className="h-4 w-4 shrink-0" />
          Install Jani
        </Button>
      </div>

      {/* Mobile: full-width banner */}
      <div className="lg:hidden">
        <div className="flex items-center gap-2 rounded-lg border border-[var(--color-primary)]/30 bg-[var(--color-primary)]/10 px-3 py-2">
          <Download className="h-4 w-4 text-[var(--color-primary)] shrink-0" />
          <span className="flex-1 text-xs font-medium text-[var(--color-primary)]">
            Install Jani on your device
          </span>
          <Button
            size="sm"
            className="h-7 px-2 text-xs bg-[var(--color-primary)] hover:bg-[var(--color-primary)]/90 text-white"
            onClick={promptInstall}
            data-testid="install-jani-button"
          >
            Install
          </Button>
          <button
            onClick={() => setDismissed(true)}
            className="ml-1 text-[var(--color-slate-400)] hover:text-white"
            aria-label="Dismiss"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>
    </div>
  );
}